/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface FetchNotificationsResponseNotifications
 */
export interface FetchNotificationsResponseNotifications {
  /**
   * The unique key for the notification.
   * @type number
   * @memberof FetchNotificationsResponseNotifications
   */
  notificationKey: number
  /**
   * The name of the notification.
   * @type string
   * @memberof FetchNotificationsResponseNotifications
   */
  name: string
  /**
   * The date and time to begin showing the notification to users.
   * @type Date
   * @memberof FetchNotificationsResponseNotifications
   */
  startDate: Date
  /**
   * The date and time to stop showing the notification to users.
   * @type Date
   * @memberof FetchNotificationsResponseNotifications
   */
  endDate: Date
}

export function FetchNotificationsResponseNotificationsFromJSON(
  json: any
): FetchNotificationsResponseNotifications {
  return FetchNotificationsResponseNotificationsFromJSONTyped(json, false)
}

export function FetchNotificationsResponseNotificationsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchNotificationsResponseNotifications {
  if (json === undefined || json === null) {
    return json
  }
  return {
    notificationKey: json['notificationKey'],
    name: json['name'],
    startDate: new Date(json['startDate']),
    endDate: new Date(json['endDate']),
  }
}

export function FetchNotificationsResponseNotificationsToJSON(
  value?: FetchNotificationsResponseNotifications | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    notificationKey: value.notificationKey,
    name: value.name,
    startDate: value.startDate.toISOString(),
    endDate: value.endDate.toISOString(),
  }
}
